<template>
  <div class="container page">
    <div v-for="(config, index) in pageConfig.content">
      <div v-if="config.type == 'container'">
        <div v-for="column in config.columns">
          <div v-for="c in column.content">
            <component-wrapper :config="c" />
          </div>
        </div>
      </div>
      <div v-if="index===0 && config.type === 'page-title'" style="height: 20px;"></div>
      <component-wrapper v-else :config="config" />
    </div>
  </div>
</template>

<script>
import ComponentWrapper from "./pageComponents/ComponentWrapper";

import mbff from "@/libs/mbff"

export default {
  components: {
    ComponentWrapper
  },
  data() {
    return {
      pageConfig: []
    };
  },
  created() {
    const id = this.$route.query.id;
    if (!id) {
      return;
    }
    window.location.href = `/modules/cms/universal/landing-page.html?key=cn--zh--${id}`;
  },
  mounted() {
    if (window.injectProperty && window.injectProperty.prerender) {
      return;
    }
    // const id = this.$route.query.id;
    // if (!id) {
    //   return;
    // }
    // const self = this;
    // mbff.get(`/content/cms/page/${id}`).then(response => {
    //   self.pageConfig = response.data;
    //   document.title = self.pageConfig.title;
    // });
  },
  methods: {}
};
</script>

<style scoped>
.container {
  font-size: 13px;
  color: #111;
  padding-bottom: 30px;
}

h1,
h2,
h3,
h4 {
  text-align: center;
  font-weight: 700;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/Page.vue